export var MessageTemplateRejectedReasonStatus;
(function (MessageTemplateRejectedReasonStatus) {
    MessageTemplateRejectedReasonStatus["None"] = "NONE";
    MessageTemplateRejectedReasonStatus["Promotional"] = "PROMOTIONAL";
    MessageTemplateRejectedReasonStatus["InvalidFormat"] = "INVALID_FORMAT";
    MessageTemplateRejectedReasonStatus["Unknow"] = "UNKNOW";
    MessageTemplateRejectedReasonStatus["IncorrectCategory"] = "INCORRECT_CATEGORY";
    MessageTemplateRejectedReasonStatus["Scam"] = "SCAM";
    MessageTemplateRejectedReasonStatus["AbusiveContent"] = "ABUSIVE_CONTENT";
})(MessageTemplateRejectedReasonStatus || (MessageTemplateRejectedReasonStatus = {}));
